<template>
  <div v-if="!emailVerified" class="overlay">
    <div class="warning">
      <p>{{ $t('dashboard.verification.message.a') }}</p>
      <p>{{ $t('dashboard.verification.message.b') }}</p>
      <VVerificationRequiredActions />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VVerificationRequiredActions from '@/views/components/VerificationRequiredActions.vue';

export default {
  name: 'VVerificationRequiredOverlay',
  components: {
    VVerificationRequiredActions,
  },
  data() {
    return {
      emailVerified: true,
    };
  },
  mounted() {
    this.$store.dispatch('company/GET').then(() => {
      this.emailVerified = this.company.email_verified;
    });
  },
  computed: {
    ...mapGetters({
      company: 'company/company',
    }),
  },
};
</script>

<style scoped>
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0,0,0,0.8);
  z-index: 3;
}

.warning {
  background: #fff;
  max-width: 450px;
  padding: var(--spacing-base);
  margin: var(--spacing-small);
  margin-bottom: 120px;
  border: 1px solid var(--color-border);
  border-radius: 3px;
}
</style>
